import React from 'react'
import styled from '@emotion/styled'

import { typographyVariants } from '@/elements'
import { Color } from '@/utils'

const TableCellElement = styled.div`
  display: flex;
  min-height: 100%;
  word-break: break-word;
  align-items: ${({ align }) => align};
  justify-content: ${({ justify }) => justify};
  text-align: ${({ justify }) => justify};
  padding: 12px 15px;
  border-style: solid;
  border-width: 0 1px 1px 0;
  border-color: ${({ $borderColor }) => $borderColor};
  background: ${({ background }) => background};
  color: ${({ color, variant }) => color || typographyVariants[variant]?.color};
  font-size: ${({ $fontSize, variant }) =>
    $fontSize || typographyVariants[variant]?.fontSize};
  font-weight: ${({ $fontWeight, variant }) =>
    $fontWeight || typographyVariants[variant]?.fontWeight};
  white-space: ${({ $whiteSpace }) => $whiteSpace};
  gap: ${({ gap }) => gap};

  &[data-selected] {
    background: ${Color.greenSmoke};
    color: ${Color.primary};
    font-weight: bold;
    border-left: 0;
    border-right: 0;
    border-top: 1px solid ${Color.primary} !important;
    border-bottom: 1px solid ${Color.primary} !important;
  }
`

export const TableCell = ({
  type,
  variant = 'body2',
  gap,
  align,
  justify,
  color,
  background,
  $borderColor = Color.opacitySkyHover,
  $fontSize,
  $fontWeight,
  $lineHeight,
  $whiteSpace,
  onClick,
  children,
  selected,
}) => (
    <TableCellElement
        className="table-cell"
        type={type}
        variant={variant}
        gap={gap}
        justify={justify}
        align={align}
        color={color}
        background={background}
        $borderColor={$borderColor}
        $fontSize={$fontSize}
        $fontWeight={$fontWeight}
        $lineHeight={$lineHeight}
        $whiteSpace={$whiteSpace}
        onClick={onClick}
        {...(selected && { 'data-selected': '' })}
    >
        {children}
    </TableCellElement>
)